/** Same list as Create Post “one department only” — keep in sync with CreatePostModal. */
export const DEPARTMENT_ONLY_OPTIONS = [
  'IT',
  'HR',
  'ADMIN',
  'Finance',
  'Sales',
  'Service',
] as const;

export function matchDepartmentOnlyOption(profileDept: string | undefined): string {
  if (!profileDept?.trim()) return '';
  return (
    DEPARTMENT_ONLY_OPTIONS.find((d) => d.toUpperCase() === profileDept.trim().toUpperCase()) ?? ''
  );
}
